import { authorizedFetch, baseUrl, removeEmpty } from './base';
import queryString from 'query-string';

async function listing(params = {}) {
  const path = `${baseUrl}/console/api/super_admin/accounts?${queryString.stringify(
    removeEmpty(params)
  )}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function getLinkAccessAccount(id) {
  const path = `${baseUrl}/console/api/super_admin/accounts/access-link/${id}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function create(params) {
  const path = `${baseUrl}/console/api/super_admin/accounts/register`;

  return await authorizedFetch(path, {
    method: 'POST',
    body: JSON.stringify(params)
  });
}

async function updatePassword(id, params) {
  const path = `${baseUrl}/console/api/super_admin/accounts/${id}/update-password`;

  return await authorizedFetch(path, {
    method: 'PUT',
    body: JSON.stringify(params)
  });
}

async function detail(id) {
  const path = `${baseUrl}/console/api/super_admin/accounts/${id}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function updateFeatures(id, params) {
  const path = `${baseUrl}/console/api/super_admin/accounts/${id}/update-feature`;

  return await authorizedFetch(path, {
    method: 'PUT',
    body: JSON.stringify(params)
  });
}

async function exportAccounts(type) {
  const path = `${baseUrl}/console/api/super_admin/accounts/export?type=${type}`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function getCurrentRole() {
  const path = `${baseUrl}/console/api/super_admin/accounts/get-current-role`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

async function getProfile() {
  const path = `${baseUrl}/console/api/super_admin/accounts/profile`;

  return await authorizedFetch(path, {
    method: 'GET'
  });
}

const accountApis = { listing, getLinkAccessAccount, create, updatePassword, detail, updateFeatures, exportAccounts, getCurrentRole, getProfile };

export default accountApis;
